import md5 from 'md5';

import Config from '../Config';

const authService = {

	destroy() {
		try {
			localStorage.removeItem('user');
			localStorage.removeItem('pass');
		}
		catch (err) {
			return;
		}
	},

	async authenticate(user, pass) {
		return new Promise(async (resolve, reject) => {
			try {
				let hashedPass = md5(pass);
				let request = new URLSearchParams();
				request.append('action', 'GetServers');
				request.append('responsetype', 'json');
				request.append('username', user);
				request.append('password', hashedPass);

				let response = await fetch(`${Config.apiBase}`, {
					method: 'POST',
					body: request
				});
				let data = await response.json();
				if (!response.ok || data.result !== 'success')
					throw new Error('Login failed: ' + (data.message || response.statusText));

				localStorage.setItem('user', user);
				localStorage.setItem('pass', hashedPass);

				resolve();
			}
			catch (err) {
				reject(err);
			}
		});
	}
};

export default authService;



// WEBPACK FOOTER //
// ./src/services/authService.js